import Vue from "vue";
import App from './App.vue'
import router from "@/router";
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'ant-design-vue/dist/antd.css';
import './assets/css/global.css'
import '@/plugins/index'
import  directive from './directive/index'
import cytoscape from 'cytoscape';
import 'w-personal-plan-ui/w-personal-plan-ui.css'
import 'w-design-ui/w-design-ui.css'
// import 'w-personal-plan-ui/w-personal-plan-ui.css'
Vue.prototype.$cytoscape = cytoscape;
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import componentLE from 'component-l-e'
import 'component-l-e/component-l-e.css'
import wDesignUi from 'w-design-ui'
import 'w-design-ui/w-design-ui.css'

import wPersonalPlanUi from 'w-personal-plan-ui'
import 'w-personal-plan-ui/w-personal-plan-ui.css'

Vue.use(wDesignUi)
Vue.use(componentLE)
Vue.use(wPersonalPlanUi)
Vue.use(ElementUI)
Vue.use(Antd);
Vue.use(directive)
new Vue({
    router,
    store,
    render: h => h(App),
    created () {
        window.addEventListener('storage', this.handleStorageChange)
    },
    beforeDestroy () {
        window.removeEventListener('storage', this.handleStorageChange)
    },
    methods: {
        handleStorageChange (event) {
         if (event.key === 'delivery_token') {
                store.state.right.token=event.newValue
            }
        }
    }
}).$mount('#app')
